// Copyright (c) StrangeBee 2024

import React from 'react';
import { ExtractProps } from '@Molecules/Details/Details';
import { THInput } from '@Molecules/Inputs/THInput/THInput';
import { THDatePicker } from '@Molecules/Inputs/THDatePicker/THDatePicker';
import { THTextArea } from '@Molecules/Inputs/THTextArea/THTextArea';
import { THForm } from '@Molecules/THForm/THForm';

import './extractData.scss';
import moment from 'moment';

interface ExtractDataProps {
    local: (label: string) => string;
    hasPermission?: boolean;
}

export const extractData = ({ local, hasPermission = false }: ExtractDataProps): Record<any, ExtractProps> => ({
    title: {
        className: 'custom-event-drawer__section',
        render: () => (
            <THForm.Item
                name="title"
                label={local('timeline.field.title')}
                rules={[{ required: hasPermission, message: local('timeline.required.general') }]}
            >
                <THInput borderless disabled={!hasPermission} />
            </THForm.Item>
        ),
    },
    description: {
        className: 'custom-event-drawer__section',
        render: () => (
            <THForm.Item
                name="description"
                label={local('timeline.field.description')}
                rules={[{ required: hasPermission, message: local('timeline.required.general') }]}
            >
                <THTextArea borderless disabled={!hasPermission} />
            </THForm.Item>
        ),
    },
    date: {
        className: 'custom-event-drawer__section',
        render: () => (
            <THForm.Item
                name="date"
                label={local('timeline.field.date')}
                rules={[{ required: hasPermission, message: local('timeline.required.general') }]}
            >
                <THDatePicker borderless disabled={!hasPermission} />
            </THForm.Item>
        ),
    },
    endDate: {
        className: 'custom-event-drawer__section',
        isForce: true,
        render: () => (
            <THForm.Item noStyle shouldUpdate>
                {({ getFieldValue }) => (
                    <THForm.Item
                        name="endDate"
                        label={local('timeline.field.endDate')}
                        rules={[
                            {
                                validator: (_, value) => {
                                    if (value === undefined || value === null) {
                                        return Promise.resolve();
                                    }
                                    const isAfter = moment(value).isAfter(getFieldValue('date'));
                                    if (!isAfter) {
                                        return Promise.reject(local('timeline.validator.earlier'));
                                    }

                                    return Promise.resolve();
                                },
                            },
                        ]}
                    >
                        <THDatePicker
                            borderless
                            placeholder={local('timeline.empty-field.endDate')}
                            disabled={!hasPermission}
                        />
                    </THForm.Item>
                )}
            </THForm.Item>
        ),
    },
});
